// Whitelist post-login redirects to the same origin. A user-supplied ?redirect
// can be a protocol-relative ("//evil.com") or absolute URL, which the browser
// would follow off-site; resolve it and drop anything that leaves our origin.
export function sanitizeRedirect(redirect, fallback = '/') {
	if(!redirect || typeof redirect !== 'string') {
		return fallback;
	}

	try {
		const resolved = new URL(redirect, window.location.origin);
		if(resolved.origin !== window.location.origin) {
			return fallback;
		}
		// Return a relative path so we never hand the browser a full URL
		return resolved.pathname + resolved.search + resolved.hash;
	} catch(e) {
		return fallback;
	}
}
